/*
 * ----------------------------------------------------------------------------------
 * Imports - External
 * ----------------------------------------------------------------------------------
 */

/**
 * Required to use React components.
 */
import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography, styled } from "@mui/material";

/**
 * Used for the copyright icon.
 */
import { faCopyright } from '@fortawesome/pro-regular-svg-icons/faCopyright';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/*
 * ----------------------------------------------------------------------------------
 * Interface
 * ----------------------------------------------------------------------------------
 */

interface IFooter {
    isPatient: boolean;
    showEq5dBlurb?: boolean;
}

/*
 * ---------------------------------------------------------------------------------
 * Functions
 * ---------------------------------------------------------------------------------
 */
const StyledFooter = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: 'center',
    background: theme.palette.grey[100],
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    width: '100%',

    ...theme.applyStyles('dark', {
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderBottom: `1px solid ${theme.palette.grey[700]}`,
    })
}))

const TranslatedFooter: React.FC<IFooter> = ({
    isPatient,
    showEq5dBlurb
}) => {
    const { t } = useTranslation();
    const supportKey = isPatient ?
        'proForm.footer.patient' : 
        'proForm.footer.staff';

    const translatedFooterContent = useMemo(() => t(supportKey), [supportKey, t]);

        // 'If you experience any technical issues, please contact your Research Nurse/Study Coordinator for support.' :
        // 'If you experience a technical difficulty please contact the BCT PROSPECTIVE team for support.';

    return (
        <>
            <StyledFooter>
                {
                    showEq5dBlurb && <Box>
                        <Typography variant="caption">
                            <FontAwesomeIcon icon={faCopyright} fixedWidth /> EuroQol Research Foundation. EQ-5D<sup>TM</sup> is a trade mark of the EuroQol Research Foundation. UK (English) v2.1
                        </Typography>
                    </Box>
                }
                <Box>
                    <Typography variant="caption">
                        {
                            translatedFooterContent
                        }
                    </Typography>
                </Box>
            </StyledFooter>
        </>
    );
}

/*
 * ----------------------------------------------------------------------------------
 * Default Export
 * ----------------------------------------------------------------------------------
 */

export default TranslatedFooter;